export default __webpack_public_path__ + "static/media/config.62209de5.svg";